import { isLiquidGlassSupported } from "@-/com.npmjs.callstack__liquid-glass";
import { Platform } from "@-/com.npmjs.react-native";

/**
 * Whether the card actions float as a glass circle to the right of the Learn page's native reading
 * tabs (iOS 26+). Elsewhere they stay in the header's More menu.
 */
export const isMorphemeCardActionsMenuInTabBar =
  Platform.OS === "android" || (Platform.OS === "ios" && isLiquidGlassSupported);
